import React, { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { setAuthToken, mainAxios } from '../../services/mainAxios';
import { toast } from 'react-toastify';
import func from '../../services/functions';


const useKeycloack = ({handleLogin}) => {
  const state=useMemo(()=>encodeURIComponent(JSON.stringify({action:"login"})),[])
  const keycloakUrl = `${process.env.REACT_APP_KEYCLOACK_URL}/realms/${process.env.REACT_APP_REALM}/protocol/openid-connect/auth?client_id=${process.env.REACT_APP_KEYCLOACK_CLIENT_ID}&redirect_uri=${encodeURIComponent(window.location.origin)}&response_type=code&scope=openid`;
  const googleUrl=`${keycloakUrl}&kc_idp_hint=google&state=${state}`
  const microsoftUrl=`${keycloakUrl}&kc_idp_hint=${process.env.REACT_APP_MICROSOFT_KC_IDP_HINT ?? "microsoft"}&state=${state}`
  const location = useLocation();
  const history= useHistory()
  useEffect(() => {
    const handleCallback = async () => {
      const queryString = location.search;
      const urlParams = new URLSearchParams(queryString);

      const code = urlParams.get('code');
      const stateRaw = urlParams.get("state");

      try {
        const state = stateRaw ? JSON.parse(decodeURIComponent(stateRaw)) : null;

        if (state?.action === "login" && code) {
          history.push('/');
          handleLogin({ keycloakCode: code, showCaptcha: false });
        }
        else if (state?.idpLinkStatus === "success" && state?.token) {
          setAuthToken(state.token);
          func.setCookie("token", state.token);

          window.history.replaceState({}, document.title, window.location.pathname);
          window.location.reload(true);
        }
        else if (state?.idpLinkStatus === "error" && state?.error) {
          console.error('IDP Link Error:', state.error);
          const errorMessage = state.error.message || 'An error occurred during IDP linking';
          toast.error(errorMessage, {
            containerId: "all_toast",
          });
          history.push('/');
        }
      } catch (error) {
        console.error('Error parsing state:', error);
      }
    };

    handleCallback();
  }, [location]); 

  return { keycloakUrl,googleUrl,microsoftUrl };
};


export default useKeycloack